/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.NotificationFilter = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The NotificationFilter model module.
   * @module model/NotificationFilter
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>NotificationFilter</code>.
   * @alias module:model/NotificationFilter
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>NotificationFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/NotificationFilter} obj Optional instance to populate.
   * @return {module:model/NotificationFilter} The populated <code>NotificationFilter</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TypeIDs')) {
        obj['TypeIDs'] = ApiClient.convertToType(data['TypeIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('StakeholderIDs')) {
        obj['StakeholderIDs'] = ApiClient.convertToType(data['StakeholderIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('RecipientUserIDs')) {
        obj['RecipientUserIDs'] = ApiClient.convertToType(data['RecipientUserIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('TextFilter')) {
        obj['TextFilter'] = ApiClient.convertToType(data['TextFilter'], 'String');
      }
      if (data.hasOwnProperty('ExcludeOwn')) {
        obj['ExcludeOwn'] = ApiClient.convertToType(data['ExcludeOwn'], 'Boolean');
      }
      if (data.hasOwnProperty('ExcludeUserID')) {
        obj['ExcludeUserID'] = ApiClient.convertToType(data['ExcludeUserID'], 'Integer');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<Integer>} TypeIDs
   */
  exports.prototype['TypeIDs'] = undefined;
  /**
   * @member {Array.<Integer>} StakeholderIDs
   */
  exports.prototype['StakeholderIDs'] = undefined;
  /**
   * @member {Array.<Integer>} RecipientUserIDs
   */
  exports.prototype['RecipientUserIDs'] = undefined;
  /**
   * @member {String} TextFilter
   * @default ''
   */
  exports.prototype['TextFilter'] = '';
  /**
   * @member {Boolean} ExcludeOwn
   * @default false
   */
  exports.prototype['ExcludeOwn'] = false;
  /**
   * @member {Integer} ExcludeUserID
   */
  exports.prototype['ExcludeUserID'] = undefined;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;



  return exports;
}));


